/* istanbul ignore file */
import { RMA_DETAIL } from 'config';

export const mapDCRToRPV3Response = (uopResponse) => {
  const { returnDetails } = uopResponse;
  const { rpShipments = [], items, contact, ...restDetails } = returnDetails;
  const rpShipment = rpShipments[0] || {};

  // Helper function to map rmaLines items from UOP to V3 format
  const mapRmaLines = (rmaItems) =>
    rmaItems.map(
      ({
        itemDetails: {
          upcNumber,
          upcSize,
          upcColor,
          mkpLineItemDetails: { sellerId, sellerName, partnerFulfillmentId } = {},
          vendorName,
          productId,
          primaryImageFilePath,
          urlTemplate,
          productName,
          hazmatDescription,
          department: { departmentId },
          withProtectionPlan,
          planDesc,
          protectionPlanPrice,
          planProviderName,
        },
        currentPrice,
        returnQuantity,
        itemTotal,
        isHazmatItem,
        reasonDescription,
      }) => ({
        upc: upcNumber,
        size: upcSize,
        color: upcColor,
        itemTotal: itemTotal || currentPrice * returnQuantity,
        sellerId,
        sellerName,
        partnerFulfillmentId,
        vendorName,
        returnQuantity,
        unitPrice: currentPrice,
        productId,
        primaryImageFilePath,
        urlTemplate,
        itemDescription: productName,
        isHazmatItem,
        hazmatDescription,
        reasonDescription,
        department: departmentId,
        withProtectionPlan,
        planDesc,
        protectionPlanPrice,
        planProviderName,
      }),
    );

  // Map rmaList items
  const rmaList = [
    {
      returnType: items[0]?.returnType,
      returnResolution: restDetails.returnResolution,
      rmaType: rpShipment.rmaType || RMA_DETAIL.RETURN_REQUIRED.TYPE,
      rmaId: restDetails.pendingReturnId || rpShipment.rmaId || restDetails.orderNumber,
      rmaStatus: rpShipment.status || restDetails.returnStatusDescription,
      returnSubmittedDate: rpShipment.returnSubmittedDate || restDetails.returnSubmittedDate,
      rmaLines: mapRmaLines(items),
      merchandiseTotal: restDetails.merchandiseTotal,
      totalTaxes: restDetails.totalTaxes,
      creditedAmount: restDetails.creditedAmount,
      batteryFee: restDetails.batteryFee,
      protectionPlanTotal: restDetails.protectionPlanTotal,
      estimatedRefund: restDetails.estimatedRefund,
      returnStatusCode: restDetails.returnStatusCode,
      refundMethod: rpShipment.refundMethod || restDetails.refundMethod,
      returnDropOffMethod: restDetails.returnDropOffMethod,
      contact: { ...contact },
      eWasteFee: restDetails.eWasteFee,
      shippingFee: restDetails.shippingFee,
      refundToAccountType: restDetails.refundToAccountType,
      refundToAccountNumber: restDetails.refundToAccountNumber,
      labelUrl: restDetails.labelUrl,
      labelImageUrl: restDetails.labelImageUrl,
      returnTrackingNumber: restDetails.returnTrackingNumber,
      labelFreeReturnTrackingNumber: restDetails.labelFreeReturnTrackingNumber,
      isDcrRedesignEnabled: restDetails.isDcrRedesignEnabled,
      resendLabelToken: restDetails.labelUrl,
      pidToken: restDetails.pidToken,
      isDcrResponse: true, // Identifier
      dropOffUrl: restDetails.dropOffUrl,
      isBorisQRCodeEnabled: restDetails.isBorisQRCodeEnabled,
    },
  ];

  // Construct and return the V3 response format
  return {
    returnResponse: [
      {
        beneficiaryUserState: returnDetails.beneficiaryUserState,
        orderNumber: restDetails.orderNumber,
        reservationNumber: restDetails.reservationNumber,
        returnEmail: restDetails.emailAddress,
        rmaList,
        fineJewelryProcessingDuration: restDetails.fineJewelryProcessingDuration,
        inTransitDuration: restDetails.inTransitDuration,
        giftCardDuration: restDetails.giftCardDuration,
        refundWindow: restDetails.refundWindow,
        orderReturnAlertMessage: restDetails.orderReturnAlertMessage,
        conditionalReturnFeeEnabled: restDetails.conditionalReturnFeeEnabled,
        eWasteFeeEnabled: restDetails.eWasteFeeEnabled,
        isMkpOrder: restDetails.isMkpOrder,
        orderToken: restDetails.orderToken,
        isBorisQRCodeEnabled: restDetails.isBorisQRCodeEnabled,
        dropOffUrl: restDetails.dropOffUrl,
        isNewGoogleAPICallEnabled: restDetails.isNewGoogleAPICallEnabled,
        isDcrResponse: true, // Identifier,
        storeInPreferenceDatabaseEnabled: restDetails.storeInPreferenceDatabaseEnabled,
        newPlacesDetailsApiEnabled: restDetails.newPlacesDetailsApiEnabled,
        purchaser: returnDetails.purchaser,
      },
    ],
  };
};
